import React, { useEffect } from 'react';
import { Box, Button, CircularProgress, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import FotoUpload from '../components/FotoUpload';
import SimpleSnackbar from '../../ui/SimpleSnackbar';
import CostActionBarMenu from '../components/CostActionBarMenu';
import ReceiptForm from './ReceiptForm';
import useReceiptForm from './useReceiptForm';

function ReceiptFormDesktop({ id, costCentreList, costObjectList }) {
    const form = useReceiptForm({ id, costCentreList, costObjectList });
    const { t } = useTranslation();

    const {
        imageUrlLocal, setImageUrlLocal, setFile, isPdf, setIsPdf,
        message, setMessage, userAccess, loading, receipt,
        costCentre, costObject, handleSubmit, handleEditCreateReceipt,
        checkCostCentre, checkCostObject
    } = form;

    useEffect(() => {
        if (!id || !receipt) return;

        const article = receipt?.logbookReceipts?.[0]?.articles?.[0];

        if (article?.costCentre && costCentre.length > 0) {
            checkCostCentre(costCentreList, costCentre);
        }

        if (article?.costObject && costObject.length > 0) {
            checkCostObject(costObjectList, costObject);
        }
    }, [id, receipt, costCentre, costObject, checkCostCentre, costCentreList, checkCostObject, costObjectList]);

    return (
        <Stack direction='column' alignItems='center'>
            <Stack
                direction='row'
                justifyContent='space-between'
                sx={{
                    width: '100%',
                    height: '65px',
                    top: '64px',
                    bgcolor: '#FAFAFA',
                    zIndex: '5',
                    py: '8px',
                }}
            >
                <Button
                    onClick={handleEditCreateReceipt}
                    sx={{
                        textAlign: 'right',
                    }}
                >
                    <CloseIcon
                        sx={{
                            width: '24px',
                            aspectRatio: 1,
                            color: 'black',
                        }}
                    />
                </Button>
                {loading && !id ? (
                    <CircularProgress size='24px' sx={{ marginTop: '16px' }} color='primary' />
                ) : (
                    userAccess < 3 && (
                        <Box display={'flex'} paddingRight={'24px'}>
                            <Button onClick={(e) => handleSubmit(e)}>{id ? t('update') : t('save')}</Button>
                            {id && <CostActionBarMenu id={id} />}
                        </Box>
                    )
                )}
            </Stack>
            <Stack
                direction='row'
                spacing={2}
                sx={{
                    width: '100%',
                    overflow: 'auto',
                    height: `${window.innerHeight - 161}px`,
                }}
            >
                <Stack
                    sx={{
                        width: '50%',
                        height: '875px',
                        border: '1px solid #E0E0E0',
                        borderRadius: '12px',
                    }}
                >
                    <FotoUpload
                        imageUrlLocal={imageUrlLocal}
                        setImageUrlLocal={setImageUrlLocal}
                        id={id}
                        setFile={setFile}
                        isPdf={isPdf}
                        setIsPdf={setIsPdf}
                    />
                </Stack>
                <Stack
                    spacing={3}
                    sx={{
                        width: '50%',
                        height: 'fit-content',
                        border: '1px solid #E0E0E0',
                        borderRadius: '12px',
                        p: 2,
                        bgcolor: 'white',
                    }}
                >
                    <ReceiptForm
                        form={form}
                        id={id}
                        variant='desktop'
                        costCentreList={costCentreList}
                        costObjectList={costObjectList}
                    />
                </Stack>
            </Stack>
            {message && <SimpleSnackbar message={message} setMessage={setMessage} />}
        </Stack>
    );
}

export default ReceiptFormDesktop;
